export const initializeMetaPixel = (facebookPixelId: string) => {
  if (!window.fbq || !facebookPixelId) return;
  fbq("init", facebookPixelId);
  fbq("track", "PageView");
};

export const fbq = (...params: any) => {
  process.env.NODE_ENV === "production" && window.fbq(params);
};
